var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isCountType)?_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('span',[_c('MeasurementValue',{attrs:{"type":_vm.type,"value":_vm.value}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }